import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MobileLayout from '../../components/mobile/MobileLayout';
import { submitPrayerRequest, useWebsiteImages, slotBackground, quote } from '../../lib/publicContent';
import { ed, usePageMeta } from '../../lib/editTexts';


export default function MobilePrayer() {
  const { t, i18n } = useTranslation();
  const slots = useWebsiteImages();
  usePageMeta('prayer');
  const [form, setForm] = useState({ name: '', anonymous: false, request: '', contact: false, phone: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.request.trim()) { setError('prayer.error.empty'); return; }
    setSending(true);
    try {
      await submitPrayerRequest({
        name: form.anonymous ? '' : form.name,
        request: form.request,
        contactRequested: !form.anonymous && form.contact,
        phoneNumber: form.phone,
      });
      setSent(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      setError('prayer.error.failed');
    } finally {
      setSending(false);
    }
  };

  const reset = () => {
    setForm({ name: '', anonymous: false, request: '', contact: false, phone: '' });
    setSent(false); setError('');
  };

  return (
    <MobileLayout>
      <section className="m-hero">
        <h1 {...ed('prayer.title')}>{t('prayer.title')}</h1>
        <p {...ed('prayer.description')}>{t('prayer.description')}</p>
      </section>

      <section style={{ padding: '0 22px 26px' }}>
        <blockquote {...ed('prayer.verse')} style={{ margin: 0, padding: '4px 0 4px 20px', borderLeft: '3px solid #C0291F', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 500, fontSize: 19, lineHeight: 1.42 }}>
          {quote(i18n.language, t('prayer.verse'))}
        </blockquote>
        <div {...ed('prayer.verse_reference')} style={{ marginTop: 12, paddingLeft: 20, fontSize: 14, fontWeight: 600, color: '#857A6E' }}>{t('prayer.verse_reference')}</div>
      </section>

      <div className="m-photo" data-slot="page.prayer" style={{ height: 200, ...slotBackground(slots, 'page.prayer', 0, '/kac-assets/photos/DSC00933.jpg', 'center top') }} />

      <section style={{ padding: '26px 22px 0' }}>
        <div className="m-card" style={{ padding: '26px 22px' }}>
          {!sent ? (
            <>
              <label className="m-label" htmlFor="m-prayer-name" {...ed('prayer.name_label')}>
                {t('prayer.name_label')}
              </label>
              <input
                id="m-prayer-name"
                className="m-input"
                type="text"
                value={form.name}
                disabled={form.anonymous}
                onChange={e => set('name', e.target.value)}
                placeholder={t('prayer.name_placeholder')}
                {...ed('prayer.name_placeholder')}
              />

              <label className="m-check" style={{ margin: '16px 0 22px' }}>
                <input type="checkbox" checked={form.anonymous} onChange={e => set('anonymous', e.target.checked)} />
                <span {...ed('prayer.anonymous')}>{t('prayer.anonymous')}</span>
              </label>

              <label className="m-label" htmlFor="m-prayer-text" {...ed('prayer.request_label')}>{t('prayer.request_label')}</label>
              <textarea
                id="m-prayer-text"
                className="m-input"
                rows={6}
                value={form.request}
                onChange={e => { set('request', e.target.value); setError(''); }}
                placeholder={t('prayer.request_placeholder')}
                style={{ resize: 'vertical', minHeight: 120 }}
                {...ed('prayer.request_placeholder')}
              />

              {!form.anonymous && (
                <label className="m-check" style={{ margin: '20px 0 0' }}>
                  <input type="checkbox" checked={form.contact} onChange={e => set('contact', e.target.checked)} />
                  <span {...ed('prayer.contact')}>{t('prayer.contact')}</span>
                </label>
              )}
              {!form.anonymous && form.contact && (
                <input
                  className="m-input"
                  style={{ marginTop: 14 }}
                  type="tel"
                  value={form.phone}
                  onChange={e => set('phone', e.target.value)}
                  placeholder={t('prayer.phone_placeholder')}
                  {...ed('prayer.phone_placeholder')}
                />
              )}

              {error && (
                <div {...ed(error)} style={{ marginTop: 18, background: '#FBEAE8', border: '1px solid rgba(192,41,31,0.25)', borderRadius: 4, padding: '12px 16px', fontSize: 14, color: '#C0291F' }}>
                  {t(error)}
                </div>
              )}

              <button
                type="button"
                onClick={submit}
                disabled={sending}
                className="m-btn m-btn-red"
                style={{ marginTop: 24, fontWeight: 700, fontSize: 16, opacity: sending ? 0.65 : 1 }}
                {...ed(sending ? 'prayer.sending' : 'prayer.submit')}
              >
                {sending ? t('prayer.sending') : t('prayer.submit')}
              </button>
            </>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 18, padding: '14px 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#1F8A5B', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M5 14l7 7L23 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 {...ed('prayer.thanks')} style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 24, margin: 0 }}>{t('prayer.thanks')}</h3>
              <p {...ed('prayer.success')} style={{ fontSize: 15, color: '#5e554b', margin: 0, lineHeight: 1.6 }}>{t('prayer.success')}</p>
              <button
                type="button"
                onClick={reset}
                {...ed('prayer.again')}
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 15, fontWeight: 600, color: '#C0291F', fontFamily: 'inherit' }}
              >
                {t('prayer.again')}
              </button>
            </div>
          )}
        </div>
      </section>
    </MobileLayout>
  );
}
